import { render, staticRenderFns } from "./classTree.vue?vue&type=template&id=842fe5ca&scoped=true"
import script from "./classTree.vue?vue&type=script&lang=js"
export * from "./classTree.vue?vue&type=script&lang=js"
import style0 from "./classTree.vue?vue&type=style&index=0&id=842fe5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842fe5ca",
  null
  
)

export default component.exports